// package imports
import { KitButton, KitCard } from 'components/common/cms-kit';
import { useTheme } from '@mui/material/styles';
import { Box, Tooltip, Typography, useMediaQuery } from '@mui/material';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

// local imports
import hex2rgba from 'services/colorUtils/hex2rgba';
import { themeColor } from '../../../services/styleUtils/colorUtils';
import { logClientException } from '../../../appinsights/clientAppInsights';
import { callApi } from '../../../services/apiWrapper';

const BehaviorCard = (props) => {
  const fields = props.item.fields;
  const theme = useTheme();
  const user = props?.user;
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

  const getSkillList = () => {
    if (
      !props.item.fields ||
      !props.item.fields.skills ||
      props.item.fields.skills.length === 0
    )
      return;
    let tagList = props.item.fields?.skills?.map((b) => {
      return (
        <span style={{ marginRight: '10px' }} key={b.fields?.skill}>
          {b.fields?.skill}
        </span>
      );
    });

    if (isSmallScreen) {
      return tagList;
    }
    if (!isSmallScreen) {
      const textList = (props.item.fields?.skills || []).map(
        (r) => r.fields?.skill,
      );

      // determine the number of tags which can fit on a line
      let maxTags = textList.length;
      for (let i = 1; i <= textList.length; i++) {
        let temp = textList.slice(0, i).join(', ');
        if (temp.length > 60) {
          maxTags = i;
          i = textList.length + 1;
        } else if (i < textList.length) {
          temp = textList.slice(0, i + 1).join(', ');
          if (temp.length > 60) {
            maxTags = i;
            i = textList.length + 1;
          }
        }
      }

      if (tagList.length <= maxTags) {
        return tagList;
      }

      const tooltipTags = textList.slice(maxTags).join(', ');
      tagList = tagList.slice(0, maxTags);
      tagList.push(
        <Tooltip title={tooltipTags} arrow>
          <MoreHorizIcon />
        </Tooltip>,
      );
      return tagList;
    }
  };

  const handleViewClick = () => {
    if (user) {
      const body = {
        user,
        event: 'open_behavior_card',
        additionalInfo: fields?.title || fields?.slug || '',
      };
      try {
        const url = '/api/db/report-event-user';
        const data = JSON.stringify(body);
        if (navigator.sendBeacon) {
          const blob = new Blob([data], { type: 'application/json' });
          navigator.sendBeacon(url, blob);
        } else {
          // Fire and forget, don't await
          callApi(url, 'POST', body);
        }
      } catch (e) {
        logClientException(e);
      }
    }

    const skills = fields?.skills
      ?.map((skill) => skill.fields?.skill)
      .join(',');
    const grades = fields?.grades
      ?.map((grade) => grade.fields?.gradeLevel)
      .join(',');
    window.location.href = `/premium-resources/common-behavioral-challenges-recommendations/${fields?.slug}?skills=${encodeURIComponent(
      skills,
    )}&grades=${encodeURIComponent(grades)}`;
  };

  return (
    <>
      <KitCard
        className="behaviorCard"
        style={{ width: '95%', borderRadius: '2px' }}
      >
        <div
          style={{
            borderTopLeftRadius: '2px',
            borderTopRightRadius: '2px',
            backgroundColor: hex2rgba(theme.palette.tertiary.main, 0.1),
            height: isSmallScreen ? '100%' : '90px',
            display: 'flex',
            alignItems: 'center',
            paddingRight: '15px',
            paddingTop: '15px',
            paddingBottom: '20px',
          }}
        >
          <Box
            sx={{
              maskImage: "url('/assets/rectangle-cbcr.svg')",
              backgroundColor: props?.tabBackGroundColor
                ? themeColor(theme, props?.tabBackGroundColor)
                : theme.palette.gold.main,
              width: '12.5px',
              height: '36px',
              color: '#4AA00',
              position: 'absolute',
              top: 9,
              left: -10,
              zIndex: -1,
            }}
          />
          <Tooltip title={fields?.title} arrow>
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: '18px',
                lineHeight: '21px',
                marginLeft: '45px',
              }}
            >
              {fields?.title}
            </Typography>
          </Tooltip>
        </div>

        <Box sx={{ margin: '15px 45px' }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <span
              style={{
                textTransform: 'uppercase',
                fontSize: '16px',
                lineHeight: '22px',
                fontWeight: 600,
                color: theme.palette.primary.light,
              }}
            >
              <KitButton
                color="primary"
                onClick={handleViewClick}
                round
                style={{
                  backgroundColor: theme.palette.primary.main,
                  marginBottom: '5px',
                  width: 108,
                  height: 32,
                  borderRadius: '41px',
                }}
              >
                View
              </KitButton>
            </span>
          </Box>
        </Box>
        <hr
          style={{
            borderTop: `1px dashed ${theme.palette.grey['A400']}`,
            width: '100%',
          }}
        />
        <Box
          sx={{
            margin: '15px 30px',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              fontSize: '13px',
              lineHeight: '22px',
              fontWeight: 400,
              color: theme.palette.text.medium,
              textTransform: 'capitalize',
            }}
          >
            {getSkillList()}
          </div>
          <div
            style={{
              fontSize: '13px',
              lineHeight: '22px',
              fontWeight: 400,
              color: theme.palette.text.medium,
              textTransform: 'capitalize',
            }}
          >
            {fields.grades &&
              fields?.grades
                .map((g) => g.fields?.gradeLevel)
                .sort()
                .join(', ')}
          </div>
        </Box>
      </KitCard>
    </>
  );
};

export default BehaviorCard;
